import React from 'react';
import 'twin.macro';
import { useParams } from 'react-router-dom';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import useUpdateUser from '@teetsh/app/src/queries/user/useUpdateUser';
import {
  ResizableHandle,
  ResizablePanel,
  ResizablePanelGroup,
} from '@teetsh/app/src/components/Resizable';
import { Sidebar } from './Sidebar';
import { Body } from './Body';
import { Form } from 'react-final-form';
import AutoSubmitForm from '@teetsh/app/src/components/AutoSave';
import { useUserAccount } from '@teetsh/app/src/queries/user/account/useUserAccount';
import useElevesViews from 'queries/eleves/views/useElevesViews';
import ScreenSpinner from 'components/Spinner/ScreenSpinner';
import { ElevesPDFSettings } from 'types/eleves';

export function ElevesListPreview() {
  const user = useUser();
  const updateUser = useUpdateUser();
  const { data: userAccount } = useUserAccount();

  const params = useParams<{
    viewId: string;
  }>();

  const { data: views, isLoading: isLoadingViews } = useElevesViews();
  const view = (views || []).find(v => v.id === params.viewId);
  if (isLoadingViews || (views || []).length === 0 || !view) {
    return <ScreenSpinner />;
  }

  return (
    <Form<ElevesPDFSettings>
      initialValues={user.fonts.eleves}
      onSubmit={async values => {
        await updateUser({
          ...user,
          fonts: {
            ...user.fonts,
            eleves: values,
          },
        });
        return {};
      }}
    >
      {({ handleSubmit }) => (
        <form tw="min-h-0 h-full" onSubmit={handleSubmit}>
          <AutoSubmitForm />
          <div tw="w-full h-full flex flex-col overflow-hidden">
            <ResizablePanelGroup
              direction="horizontal"
              autoSaveId="eleves-preview-sidebar"
            >
              <Sidebar
                viewId={params.viewId as string}
                viewName={view?.name as string}
                lng={user.locale}
                limitedBgSet={userAccount?.isOnOldPricing || false}
              />
              <ResizableHandle />
              <ResizablePanel order={1}>
                <div tw="h-full overflow-auto">
                  <Body
                    viewId={params.viewId as string}
                    userId={user.id}
                    lng={user.locale}
                  />
                </div>
              </ResizablePanel>
            </ResizablePanelGroup>
          </div>
        </form>
      )}
    </Form>
  );
}
